// extracted by css-extract-rspack-plugin
export default {"tocCollapsible":"tocCollapsible_O_Qc","tocCollapsibleContent":"tocCollapsibleContent_SlnY","tocCollapsibleExpanded":"tocCollapsibleExpanded_klrc"};